export function setChargebackPayments({commit}, payload) {
  commit('SET_CHARGEBACK_PAYMENTS', payload);
};
